module.exports = __webpack_public_path__ + "img/logo-cotizacion.b4a3b2c7.png";